<h1 class="page-title text-start">{{ 'contact_us.about.title' | translate }}</h1>

<section class="bg-[#F6F6F6] w-full max-w-[1440px] min-h-screen px-4 pt-6 pb-6 rounded-[16px] mx-auto">

  <section class="bg-white rounded-[16px] shadow-md min-h-screen max-w-[1408px] mx-auto px-4 py-4 space-y-6">


    <section class="relative w-full">
      <img src="/image/about-us-header.png" [alt]="'contact_us.about.title' | translate"
        class="w-full rounded-[16px] object-cover" />
      <div
        class="absolute -bottom-8 end-4 w-[60px] h-[60px] rounded-full bg-white shadow flex items-center justify-center">
        <i class="bi bi-info-circle text-gray-600 text-[25px]"></i>
      </div>
    </section>


    <section class="font-semibold text-start text-[#4B4B4B] mt-12 ms-5 text-[16px]">{{ 'contact_us.about.app_name' | translate }}</section>


    <div class="ms-5 flex items-center justify-start text-[#4B4B4B] text-[16px] gap-2">
      <i class="bi bi-pin-angle-fill text-[#858585]"></i>
      <span class="font-semibold">{{ 'contact_us.about.who_we_are.heading' | translate }}</span>
    </div>

    <p class="text-start text-[#121217] text-[12px] mx-auto px-2">
      {{ 'contact_us.about.who_we_are.body' | translate }}
    </p>


    <div class="ms-5 flex items-center justify-start text-[#4B4B4B] text-[16px] gap-2">
      <i class="bi bi-pin-angle-fill text-[#858585]"></i>
      <span class="font-semibold">{{ 'contact_us.about.mission.heading' | translate }}</span>
    </div>

    <p class="text-start text-[#121217] text-[12px] mx-auto px-2">
      {{ 'contact_us.about.mission.body' | translate }}
    </p>


    <div class="ms-5 flex items-center justify-start text-[#4B4B4B] text-[16px] gap-2">
      <i class="bi bi-pin-angle-fill text-[#858585]"></i>
      <span class="font-semibold">{{ 'contact_us.about.vision.heading' | translate }}</span>
    </div>

    <p class="text-start text-[#121217] text-[12px] mx-auto px-2">
      {{ 'contact_us.about.vision.body' | translate }}
    </p>


    <ul
      class="list-disc list-inside text-start text-[#121217] text-[12px] leading-relaxed space-y-2 mx-auto px-2">
      <li><span>{{ 'contact_us.about.values.comfort_label' | translate }}</span> {{ 'contact_us.about.values.comfort_body' | translate }}</li>
      <li><span>{{ 'contact_us.about.values.trust_label' | translate }}</span> {{ 'contact_us.about.values.trust_body' | translate }}</li>
      <li><span>{{ 'contact_us.about.values.innovation_label' | translate }}</span> {{ 'contact_us.about.values.innovation_body' | translate }}</li>
      <li><span>{{ 'contact_us.about.values.variety_label' | translate }}</span> {{ 'contact_us.about.values.variety_body' | translate }}</li>
    </ul>


  </section>
</section>
